import { render, staticRenderFns } from "./SkillsTableRow.vue?vue&type=template&id=9faee846&scoped=true&"
import script from "./SkillsTableRow.vue?vue&type=script&lang=js&"
export * from "./SkillsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faee846",
  null
  
)

export default component.exports